import { HorizontalBarRepresentation } from "../../components/shared/charts/BarRepresentation";
import COLOR from "../../theme/colors";

const RegistrationMethods = ({ registrationMethods }) => {
    const {
        datapoints = [],
        title = "",
        // xLabel = "",
        // yLabel = ""
    } = registrationMethods || {};
    return (
        <HorizontalBarRepresentation
            data={datapoints}
            title={title}
            color={COLOR.BAR_CHART}
            xAxisDataKey={"value"}
            yAxisDataKey={"count"}
        />
    );
};

export default RegistrationMethods;
